import { Component, OnDestroy, OnInit } from '@angular/core';
import { Fatura } from '../model/fatura';
import { StokListePage } from 'src/model/stok-liste-page';
import { CariListePage } from 'src/model/cari-liste-page';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from 'src/providers/rest.service';
import { Master } from 'src/model/master';
import { FaturaKaydetRequest } from 'src/model/fatura-kaydet-request';
import { Cari } from 'src/model/cari';
import { Sube } from 'src/model/sube';
import { AuthService } from 'src/auth/auth.service';
import { StokListe } from 'src/model/stok-liste';
import { FaturaKalem } from 'src/model/fatura-kalem';
import { FaturaFaturaOnaySeviye } from 'src/model/fatura-fatura-onay-seviye';
import { FaturaOnaylaRequest } from 'src/model/fatura-onayla-request';
import { FaturaGorsel } from 'src/model/fatura-gorsel';
import { FaturaAciklama } from 'src/model/fatura-aciklama';
import { ToastrService } from 'ngx-toastr';
import { Talep } from 'src/model/talep';
import { ParaBirimiTutar } from 'src/teklif/teklif.component';
import { Kullanici } from 'src/model/kullanici';
import { HesapPlani } from 'src/model/hesap-plani';
import { TalepAciklama } from 'src/model/talep-aciklama';
import { TalepGorsel } from 'src/model/talep-gorsel';
// import { debug } from 'console';

declare var $: any;

@Component({
  selector: 'app-fatura',
  templateUrl: './fatura.component.html',
  styleUrls: ['./fatura.component.css']
})
export class FaturaComponent implements OnInit, OnDestroy {
  id = '0';
  fatura: Fatura = new Fatura();
  showSearchResultCount = 10;
  showSearchResultCountCari = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  showSearchResultCountModelCari: number[] = [10, 20, 50, 100];
  showSearchCurrentPage = 1;
  showSearchCurrentPageCari = 1;
  showSearchResultText = '';
  showSearchResultTextCari = '';
  kalemAraText = '';
  cariAraText = '';
  muhSubeKoduFilter = 0;
  searchResults: StokListePage = null;
  searchResultsCari: CariListePage = null;
  kalemAraLoading = false;
  cariAraLoading = false;
  // showSelectUrunGrupModalTs: number = null; // farklı id verince açılıyor.
  // selectedUrunGrup: UrunGrup = null;
  private subscriptions: Subscription[] = [];
  user: Kullanici;
  faturaHareketler: FaturaFaturaOnaySeviye[] = null;

  faturaTipleri: Master[] = null;
  secilenCari: Cari;
  subeler: Sube[] = null;
  sarfYeriList: Master[] = null;
  paraBirimList: Master[] = null;

  aciklamaGecmisiFatura: FaturaAciklama[];
  aciklamaGecmisiTalep: TalepAciklama[];

  talepGorseller: TalepGorsel[];

  talepId: number = null;
  talep: Talep;
  genelToplamText = '';
  brutToplamText = '';
  kdv1Toplam = '';
  kdv8Toplam = '';
  kdv18Toplam = '';

  showSelectHesapPlaniModalTs: number = null; // farklı id verince açılıyor.
  hesapPlani: HesapPlani;
  seciliKalem: any;

  constructor(private route: ActivatedRoute,
    private restService: RestService,
    private router: Router,
    private authService: AuthService,
    private toastService: ToastrService) {
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit(): void {
    // this.helperProvider.currentPage$.next(Page.Faturalar);
    this.user = this.authService.getUser();
    this.getKullaniciSubeler();

    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.id = params.id;

      if (params.talepId) {
        this.talepId = params.talepId;
      }

      if (!params.id) {
        this.id = '0';
      }

      if (this.id === '0') {
        this.fatura.id = null;
        this.fatura.faturaNo = "";
        this.fatura.faturaTipId = null;
        this.fatura.cariId = null;
        this.fatura.tarih = null;
        this.fatura.malHizmetCinsi = "";
        this.fatura.malHizmetMiktar = "";
        this.fatura.faturaSeriNo = "";
        this.fatura.aciklama = "";
        this.fatura.subeId = null;
        this.fatura.faturaKalemler = [];
        this.fatura.faturaGorseller = [];

        if (this.talepId !== null) {
          this.getTalepDetaylar();
        }
      }
      else {
        this.getFaturaDetails();
      }
    }));

    this.getMaster();
  }

  getKullaniciSubeler() {
    this.restService.kullaniciSubeleri().subscribe(res => {
      this.subeler = res;
      const subeler = this.authService.getSelectedSubeIdList();
      if (subeler != null && subeler.length === 1 && this.subeler.findIndex(x => x.id === subeler[0]) !== -1) {
        this.fatura.subeId = subeler[0];
      }
    });
  }

  getMaster() {
    const types = [
      Master.FaturaTipi,
      Master.SarfYeri,
      Master.ParaBirimi
    ];

    this.restService.getMasterTypes(types).subscribe(res => {
      this.faturaTipleri = res?.FaturaTipi?.map(x => new Master(x));
      this.sarfYeriList = res?.SarfYeri?.map(x => new Master(x));
      this.paraBirimList = res?.ParaBirimi?.map(x => new Master(x));
    });
  }

  getFaturaDetails() {
    this.restService.faturaDetaylar(this.id).subscribe(res => {
      if (res) {
        this.fatura = res;
        // console.log(this.fatura)
        this.secilenCari = res.cari;
        this.aciklamaGecmisiFatura = res.faturaAciklamalar;

        if (res.talep) {
          this.aciklamaGecmisiTalep = res.talep.talepAciklamalar;
          this.talepGorseller = res.talep.talepGorseller;
        }

        this.toplamHesapla();

        this.restService.getFaturaHareketler(this.id).subscribe(res2 => {
          this.faturaHareketler = res2;
        });
      }
    });
  }

  faturaOnayla(id: number, isOnay: boolean) {
    const request = new FaturaOnaylaRequest();
    request.faturaId = this.fatura.id;
    request.faturaOnaySeviyeId = id;
    request.isOnay = isOnay;
    this.restService.faturaOnayla(request).subscribe(res => {
      this.getFaturaDetails();
    });
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.kalemAra();
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.kalemAra();
  }

  kalemAraInputChange() {
    this.showSearchCurrentPage = 1;
    this.kalemAra();
  }

  kalemAra() {
    if (this.fatura.subeId === null) {
      this.toastService.warning("Şube Seçiniz!", "Uyarı");
      return;
    }

    if (this.showSearchResultCount < 1) {
      this.showSearchResultCount = 10;
    }
    if (this.showSearchResultCount > 100) {
      this.showSearchResultCount = 100;
    }
    if (this.kalemAraText.length > 3) {
      this.kalemAraLoading = true;
      setTimeout(() => {
        this.kalemAraLoading = false;
      }, 10000);
      this.searchResults = null;

      this.restService.kalemAra(this.kalemAraText
        , this.subeler.find(x => x.id === this.fatura.subeId).kodu
        , this.showSearchCurrentPage, this.showSearchResultCount).subscribe(res => {
          if (res) {
            this.searchResults = res;
            this.showSearchResultText = this.kalemAraText;
          }
          this.kalemAraLoading = false;
        });
    }
  }

  removeFromRequestList(rowId: number) {

    $('#cart' + rowId).addClass('target2-highlight');
    setTimeout(() => {
      $('#cart' + rowId).removeClass('target2-highlight');
      this.fatura.faturaKalemler.splice(rowId, 1);
    }, 1000);

    setTimeout(() => {
      this.toplamHesapla();
    }, 1000);
  }

  addToRequestList(k: StokListe, rowId: string) {
    const index = this.fatura.faturaKalemler.findIndex(x => x.stokKodu === k.stokKodu && x.stokAdi === k.stokAdi && x.ekAlan === k.ekAlan && x.sarfYeriId === k.sarfYeriId);
    if (index !== -1) {
      this.fatura.faturaKalemler[index].miktar += Number(k.talepEdilen);
    } else {

      if (k.talepEdilen == null) {
        alert('Lütfen miktar giriniz!');
        return;
      }

      if (k.birimFiyat == null) {
        alert('Lütfen birim fiyat giriniz!');
        return;
      }

      if (k.paraBirimiId == null) {
        alert('Lütfen doviz tipini seçiniz!');
        return;
      }

      if (k.sarfYeriId == null) {
        alert('Lütfen sarf yerini seçiniz!');
        return;
      }

      if (k.muhasebeKodu == null) {
        alert('Lütfen muhasebe kodunu seçiniz!');
        return;
      }

      const item = new FaturaKalem();
      item.stokKodu = k.stokKodu;
      item.stokAdi = k.stokAdi;
      item.ekAlan = k.ekAlan;
      item.miktar = k.talepEdilen;
      item.olcuBirimi = k.olcuBirimi;
      item.birimFiyat = k.birimFiyat;
      item.paraBirimiId = k.paraBirimiId;
      item.kdvOrani = k.kdvOrani;
      item.muhasebeKodu = k.muhasebeKodu;
      item.sarfYeriId = k.sarfYeriId;
      item.grupKodu = k.grupKodu;
      item.kod1 = k.kod1;
      this.fatura.faturaKalemler.push(item);
    }
    $('#' + rowId).addClass('target-highlight');
    setTimeout(() => {
      $('#' + rowId).removeClass('target-highlight');
    }, 3000);

    this.toplamHesapla();
  }

  save() {
    if (this.fatura.malHizmetCinsi.length > 100) {
      this.toastService.error("Mal veya Hizmet Cinsi 100 karakterden fazla olamaz")
    } else {
      if (this.fatura.subeId === null) {
        alert('Lütfen şube seçiniz!');
        return;
      }

      if (this.fatura.faturaNo == "") {
        alert('Fatura numarası boş bırakılamaz!');
        return;
      }

      if (this.fatura.faturaNo.length > 15) {
        alert('Fatura numarası 15 karakterden fazla olamaz!');
        return;
      }

      if (this.fatura.faturaTipId == null) {
        alert('Lütfen fatura tipini seçiniz!');
        return;
      }

      if (this.fatura.tarih == null) {
        alert('Tarih boş bırakılamaz!');
        return;
      }

      if (this.secilenCari == null) {
        alert('Cari seçiniz!');
        return;
      }

      if (this.fatura.faturaKalemler.length == 0) {
        alert('Fatura kalemi giriniz!');
        return;
      }

      for (const kalem of this.fatura.faturaKalemler) {
        if (kalem.miktar === undefined || kalem.miktar === null ||
          kalem.birimFiyat === undefined || kalem.birimFiyat === null ||
          kalem.paraBirimiId === undefined || kalem.paraBirimiId === null ||
          kalem.sarfYeriId === undefined || kalem.sarfYeriId === null ||
          kalem.muhasebeKodu === undefined || kalem.muhasebeKodu === null) {
          alert('Fatura kalemlerinde eksik bilgi mevcut!');
          return;
        }
      }

      const isNewParam = this.fatura.id === null ? '1' : '0';
      const request = new FaturaKaydetRequest();

      request.id = this.fatura.id;
      request.subeId = this.fatura.subeId;
      request.faturaNo = this.fatura.faturaNo;
      request.faturaTipId = this.fatura.faturaTipId;
      request.cariId = this.secilenCari.id;
      request.tarih = this.fatura.tarih;
      request.malHizmetCinsi = this.fatura.malHizmetCinsi;
      request.malHizmetMiktar = this.fatura.malHizmetMiktar;
      request.faturaSeriNo = this.fatura.faturaSeriNo;
      // request.aciklama = this.fatura.aciklama;
      request.faturaGorseller = this.fatura.faturaGorseller;
      request.faturaKalemler = this.fatura.faturaKalemler;

      if (this.fatura.aciklama !== "" && this.fatura.aciklama != null) {
        request.faturaAciklama = new FaturaAciklama();
        request.faturaAciklama.aciklama = this.fatura.aciklama;
      }

      if (this.talepId != null)
        request.talepId = this.talepId;

      console.log(request)
      this.restService.faturaKaydet(request).subscribe(res => {
        if (res != null)
          this.router.navigate(['fatura-olusturuldu'], { queryParams: { id: res.id, isNew: isNewParam } });
      });
    }

  }

  cariAra() {
    if (this.showSearchResultCountCari < 1) {
      this.showSearchResultCountCari = 10;
    }
    if (this.showSearchResultCountCari > 20) {
      this.showSearchResultCountCari = 20;
    }
    if (this.cariAraText.length > 3) {
      this.cariAraLoading = true;
      setTimeout(() => {
        this.cariAraLoading = false;
      }, 10000);
      this.searchResultsCari = null;
      this.restService.cariAra(this.cariAraText, this.showSearchCurrentPageCari, this.showSearchResultCountCari).subscribe(res => {
        if (res) {
          this.searchResultsCari = res;
          this.showSearchResultTextCari = this.cariAraText;
        }
        this.cariAraLoading = false;
      });
    }
  }

  showPreviousPageSearchResultsCari() {
    this.showSearchCurrentPageCari--;
    this.cariAra();
  }

  showNextPageSearchResultsCari() {
    this.showSearchCurrentPageCari++;
    this.cariAra();
  }

  cariAraInputChange() {
    this.showSearchCurrentPageCari = 1;
    this.cariAra();
  }

  addCari(c: Cari) {
    this.secilenCari = c;
    this.cariAraText = "";
    this.searchResultsCari = null;
    // if (this.teklifIsteFirmalar.findIndex(x => x.id === c.id) !== -1) {
    //   alert('Bu firma zaten eklendi');
    //   return;
    // }
    // this.teklifIsteFirmalar.push(c);
  }

  onFileChanged(event): void {
    const file = event.target.files[0];
    this.restService.uploadFile(file).subscribe(res => {
      if (res != null && res.file != null) {
        const gorsel = new FaturaGorsel();
        gorsel.dosya = res.file;
        this.fatura.faturaGorseller.push(gorsel);
      }
    });
  }

  removeGorsel(index: number) {
    this.fatura.faturaGorseller.splice(index, 1);
  }

  downloadFile(fileName: string) {
    this.restService.downloadFile(fileName).subscribe(res => {

    });
  }

  getTalepDetaylar() {
    this.restService.talepDetaylar(this.talepId).subscribe(res => {
      if (res) {
        this.talep = res;
        this.talepGorseller = this.talep.talepGorseller;
        this.aciklamaGecmisiTalep = this.talep.talepAciklamalar;

        this.secilenCari = res.cari;
        this.fatura.subeId = res.subeId;

        for (const talepKalem of res.talepKalemler) {
          debugger;
          const item = new FaturaKalem();
          item.stokKodu = talepKalem.stokKodu;
          item.stokAdi = talepKalem.stokAdi;
          item.miktar = talepKalem.talepEdilen;
          item.olcuBirimi = talepKalem.olcuBirimi;
          item.sarfYeriId = talepKalem.sarfYeriId;

          this.restService.kalemAra(item.stokKodu,
            this.subeler.find(x => x.id === this.fatura.subeId).kodu,
            1, 1).subscribe(res => {
              debugger;
              item.muhasebeKodu = res.results[0].muhasebeKodu;
              item.kdvOrani = res.results[0].kdvOrani;
            });

          this.fatura.faturaKalemler.push(item);
        }
      }
    });
  }

  toplamHesapla() {
    const array: ParaBirimiTutar[] = [];
    let kdv1 = 0;
    let kdv8 = 0;
    let kdv18 = 0;
    this.kdv1Toplam = '';
    this.kdv8Toplam = '';
    this.kdv18Toplam = '';
    this.brutToplamText = '';
    this.genelToplamText = '';

    if (this.paraBirimList) {
      for (const pb of this.paraBirimList) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }

    for (const t of this.fatura.faturaKalemler) {
      // console.log(this.fatura.faturaKalemler.length)
      const index = array.findIndex(x => x.paraBirimi.id === t.paraBirimiId);
      if (index !== -1) {
        array[index].tutar += t.birimFiyat * t.miktar;
        array[index].toplamTutar += (t.birimFiyat * t.miktar) * (1 + t.kdvOrani / 100);
      }

      if (t.kdvOrani === 1) {
        kdv1 += ((t.birimFiyat * t.miktar) * 0.01);
        this.kdv1Toplam = kdv1.toLocaleString('tr-TR');
      }
      else if (t.kdvOrani === 8) {
        kdv8 += (t.birimFiyat * t.miktar) * 0.08;
        this.kdv8Toplam = kdv8.toLocaleString('tr-TR');
      }
      else if (t.kdvOrani === 18) {
        kdv18 += (t.birimFiyat * t.miktar) * 0.18;
        this.kdv18Toplam = kdv18.toLocaleString('tr-TR');
      }
      else if (t.kdvOrani === null && t.stokKodu === "HIZMET 1")
      {
        kdv1 += (t.birimFiyat * t.miktar) * 0.01;
        this.kdv1Toplam = kdv1.toLocaleString('tr-TR');
      }
      else if (t.kdvOrani === null && t.stokKodu === "HIZMET 8")
      {
        debugger;
        kdv8 += (t.birimFiyat * t.miktar) * 0.08;
        this.kdv8Toplam = kdv8.toLocaleString('tr-TR');
      }
      else if (t.kdvOrani === null && t.stokKodu === "HIZMET 18")
      {
        kdv18 += (t.birimFiyat * t.miktar) * 0.18;
        this.kdv18Toplam = kdv18.toLocaleString('tr-TR');
      }
    }

    const textArrayBrut = [];
    const textArrayGenel = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArrayBrut.push(`${e.tutar.toLocaleString('tr-TR')} ${e.paraBirimi.aciklama}`);
        textArrayGenel.push(`${e.toplamTutar.toLocaleString('tr-TR')} ${e.paraBirimi.aciklama}`);
      }
    }
    this.brutToplamText = textArrayBrut.join(' + ');
    this.genelToplamText = textArrayGenel.join(' + ');
  }

  selectHesapKodu(event: string) {
    if (event) {
      this.seciliKalem.muhasebeKodu = event;
    }
  }

  showSelectHesapKodu(k: any) {
    this.seciliKalem = k;
    this.showSelectHesapPlaniModalTs = new Date().getTime();
  }
}